import {generateID} from "../../helpers/generateID";
import {SectionInterface, StoreWallInterface} from "../../types/store";
import {partsProperties} from "../../../shared";

interface getCopySectionInterface {
    currentShelving: StoreWallInterface;
    section: SectionInterface
}

export const getCopySection = ({currentShelving, section}: getCopySectionInterface) => {
    const offset = currentShelving.sections.reduce((acc, curr) => acc + curr.width - partsProperties.railing.vertical.doubleWidth, 0);
    if (offset + section.width < currentShelving.length) {
        const diffOffset = offset - section.offset
        const id = generateID();
        const newCopyItems = section.items.map(item => {
            const newId = generateID();
            const position = [item.position[0] + diffOffset / 1000, item.position[1], item.position[2]]
            if (Array.isArray(item.brackets.left.position) && Array.isArray(item.brackets.right.position)) {
                const leftBracketPosition = [item.brackets.left.position?.[0] + diffOffset / 1000, item.brackets.left.position?.[1], item.brackets.left.position?.[2]]
                const rightBracketPosition = [item.brackets.right.position?.[0] + diffOffset / 1000, item.brackets.right.position?.[1], item.brackets.right.position?.[2]]
                return {
                    ...item, id: newId, position,
                    brackets: {
                        ...item.brackets,
                        left: {...item.brackets.left, position: leftBracketPosition},
                        right: {...item.brackets.right, position: rightBracketPosition}
                    }
                }
            }
            return {...item, id: newId, position}

        })
        const newSections = [...currentShelving.sections];
        newSections.push({...section, offset, id, items: newCopyItems});
        return newSections;
    }
    return currentShelving.sections;
};
